<template>
  <div class="d-flex flex-column">
    <a
      v-for="(action, index) in device.actions"
      :key="index"
      href="#"
      @click.prevent="handleClick(action)"
      style="margin-bottom: 5px"
      class="dmp-output-action"
    >
      <span :class="action.icon" class="mr-1"></span>
      <span>{{ trans[action.name] || action.name }}</span>
    </a>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import { useDeviceMessages } from "./composables/useDeviceMessages";
import axios from "@axios";

export default {
  name: "DmpOutput",
  props: {
    device: Object,
    trans: Object,
    loadingToast: Object,
    updateStatus: Function,
  },
  setup(props) {
    const { confirmActionAlert, successAlertAction, errorAlertAction, showToast } =
      useDeviceMessages(props.trans);
    const localLoading = ref(false);

    const handleClick = async (action) => {
      const result = await confirmActionAlert(props.device, action);

      if (!result.isConfirmed) return;

      localLoading.value = true;
      showToast(props.device.status, props.device, props.loadingToast);

      try {
        const urlAction = action.data.url;

        await axios.get(urlAction);

        // Deprecated
        //props.updateStatus();

        successAlertAction(props.device, action);
      } catch (error) {
        console.error(
          `error in request for device ${props.device.text}:`,
          JSON.stringify(error)
        );
        errorAlertAction(props.device.status, error.response?.data?.message);
      } finally {
        localLoading.value = false;
        if (props.loadingToast) props.loadingToast.close();
      }
    };

    return { handleClick, localLoading };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";
.dmp-output-action {
  .dark-layout & {
    color: $theme-dark-headings-color;
    &:hover {
      color: $theme-dark-label-color;
    }
  }
}
</style>
